import KinerjaLayout from 'app/KinerjaPage/components/KinerjaDemoLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { RangkumanPenilaianKinerja } from 'app/KinerjaPage/pages/PelaksanaanV2/PenilaianKinerja/RangkumanPenilaianKinerja'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isPenetapanPenilaianKinerjaEnabled =
      process.env.NEXT_PUBLIC_SKP_FORM_F_ENABLED === 'true'

    const npsn = 'demo'

    if (
      !toggle?.['kinerja-enabled'] ||
      !toggle?.['kinerja-pelaksanaan-enabled'] ||
      !toggle?.['kinerja-penilaian-demo-mode-enabled'] ||
      !isPenetapanPenilaianKinerjaEnabled
    ) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return {
      props: {
        npsn,
      },
    }
  },
})

const RangkumanPenilaianKinerjaPage: KinerjaApp = ({
  npsn,
}: PageProps & { npsn: string }) => {
  return <RangkumanPenilaianKinerja npsn={npsn} />
}

export default RangkumanPenilaianKinerjaPage

RangkumanPenilaianKinerjaPage.Layout = KinerjaLayout

RangkumanPenilaianKinerjaPage.layoutOpts = {}
